<template>
    <v-dialog v-model="show" no-click-animation persistent width="600">
        <div class="AgentFallback">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('fallback') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="dialog-content fci-scrollbar">
                <!--Falllback-->
                <div class="label mt-0">Fallback</div>
                <v-select
                    hide-details outlined
                    v-model="fallback"
                    :items="fallbackList"
                    class="input-custom"
                    :readonly="!isEdit"
                ></v-select>

                <!--Prompt-->
                <div class="label">Prompt</div>
                <v-textarea
                    hide-details
                    v-model="fallback_prompt"
                    :readonly="!isEdit"
                    class="textarea-custom"
                ></v-textarea>
                <div v-if="fallback === FallbackType.SUPPORTER">
                    <div class="label">{{ $f.tc('phone') }}</div>
                    <v-text-field
                        hide-details
                        v-model="fallback_phone"
                        class="input-custom"
                        :readonly="!isEdit"
                    ></v-text-field>
                </div>
            </div>
            <!--Footer dialog-->
            <div class="dialog-footer" v-if="isEdit">
                <div class="btn-custom"
                     @click="saveSetting">{{ $f.tc('save') }}
                </div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin.vue";
import {mapState} from "vuex";
import AgentService from "@/services/agent.service";

const FallbackType = {
    END: 'end_call',
    SUPPORTER: 'transfer_to_agent'
}

export default {
    name: 'AgentFallback',
    mixins: [DialogPromiseMixin],
    computed: {
        ...mapState({
            fallbackSetting: state => state.agent.fallback
        }),
        isEdit() {
            return AgentService.isEditable()
        },
    },
    data() {
        return {
            FallbackType,
            fallback_prompt: '',
            fallback_phone: '',
            fallback: '',
            fallbackList: [
                {
                    text: 'end call',
                    value: FallbackType.END
                },
                {
                    text: 'switch to supporter',
                    value: FallbackType.SUPPORTER
                }
            ],
        }
    },
    methods: {
        open() {
            this.show = true
            this.loadFallback()
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        loadFallback() {
            if (Object.keys(this.fallbackSetting.value).length !== 0) {
                let value = this.fallbackSetting.value
                this.fallback = value.type
                this.fallback_prompt = value.content.prompt
                if (this.fallback === FallbackType.SUPPORTER) {
                    this.fallback_phone = value.content.phone_number
                }
            }
            this.fallback = this.fallbackSetting.value.type
        },
        saveSetting() {
            this.$store.dispatch(this.$actionTypes.agent.UPDATE_FALLBACK, {
                id: this.fallbackSetting.id,
                value: {
                    type: this.fallback,
                    content: {
                        prompt: this.fallback_prompt,
                        phone_number: this.fallback === FallbackType.SUPPORTER ? this.fallback_phone : ""
                    }
                }
            })
        },
        close () {
            this.show = false
            this.fallback_prompt = ''
            this.fallback_phone = ''
            this.$emit('close')
        }
    }
}
</script>

<style scoped lang="scss">
.AgentFallback {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-content {
        padding: 12px;
        max-height: calc(85vh - 100px);
        overflow-y: auto;
    }

    .btn-custom {
        margin-right: 8px;
    }
}

.textarea-custom, .input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            outline-offset: 0;
            font-size: 14px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            padding: 6px 12px;
        }
    }
}

.textarea-custom {
    ::v-deep {
        textarea {
            padding: 8px 12px !important;

            &::-webkit-scrollbar {
                width: 7px;
                height: 10px;
                background-color: transparent;
                border: none;
            }

            &::-webkit-scrollbar-track {
                background-color: transparent;
                border: none;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background: rgba(0, 0, 0, 0.1);
                border: none;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: rgba(0, 0, 0, 0.5);
            }
        }
    }
}
</style>
